import { sample } from 'lodash'

const adjectives = [
  'Big',
  'Colossal',
  'Gigantic',
  'Great',
  'Huge',
  'Little',
  'Delightful',
  'Large',
  'Miniature',
  'Scrawny',
  'Tall',
  'Teeny',
  'Happy',
  'Gorgeous',
  'Plain',
  'Wonderful',
  'Happy',
  'Candy',
  'Jolly',
  'Stoney',
  'Pebble',
  'Cobble',
  'Massive',
  'Tiny',
  'Enormous',
  'Petite',
  'Vast',
  'Mighty',
  'Charming',
  'Elegant',
  'Radiant',
  'Dull',
  'Splendid',
  'Joyful',
  'Cheerful',
  'Rocky',
  'Smooth',
  'Bumpy',
  'Shiny',
  'Gleaming',
  'Sparkling',
  'Dainty',
  'Sturdy',
  'Robust',
  'Fragile',
]

const names = [
  'Statue',
  'Island',
  'Tower',
  'Road',
  'Block',
  'Bridge',
  'Court',
  'House',
  'Rock',
  'Bend',
  'Mountain',
  'Hill',
  'Fountain',
  'Palace',
  'Mansion',
  'River',
  'Park',
  'Garden',
  'Lake',
  'Forest',
  'Beach',
  'Cave',
  'Tunnel',
  'Path',
  'Trail',
  'Cliff',
  'Valley',
  'Pond',
  'Stream',
  'Waterfall',
  'Village',
  'City',
  'Temple',
  'Castle',
  'Fortress',
  'Harbor',
]

const generateRandomName = () => `${sample(adjectives)} ${sample(names)}`
export { generateRandomName }
